// const validateRequiredFields = (data, missingFieldsObj) => {
//   const tempMissingFields = { ...missingFieldsObj };

//   // Iterate over the required fields in the `data` object
//   Object.keys(data).forEach((fieldName) => {
//     tempMissingFields[fieldName] = !data[fieldName]; // true if missing, false if has a value
//   });

//   return tempMissingFields;
// };

// export default validateRequiredFields

const validateRequiredFields = (inputElements, missingFieldsObj) => {


     // const inputElements = document.querySelectorAll('input');

     // Filter those that have the 'required' attribute
     const requiredInputs = Array.from(inputElements).filter(input => input.hasAttribute('required'));
     // Temporary object to store missing fields
     let tempMissingFields = {...missingFieldsObj};
   
     // Check for missing required inputElements
    //  requiredInputs.forEach(inputHtml => {
    //    let inputElement = document.getElementById(inputHtml.name); // text inputs, can be switched to inputHtml.id (.name cause ReactSelect wraps everything in a div)
    //   if (inputElement.type === 'checkbox') {
    //     console.log('inputEl', inputElement)
    //     if (!inputElement?.checked) {
    //       tempMissingFields[inputHtml.name] = true
    //     }
    //     else {
    //       tempMissingFields[inputHtml.name] = false
    //     }
    //   }

    //    else {if (!inputElement?.value) {
    //      tempMissingFields[inputHtml.name] = true;  // Update the temporary object
    //    } 
    //   //  else if (inputValue === undefined) {
    //   //   tempMissingFields[inputHtml.name] = true
    //   //  }
    //    else {
    //      tempMissingFields[inputHtml.name] = false; // Ensure field is marked not missing
    //    }}
    //   }
    //   );

    requiredInputs.forEach(inputHtml => {
      const inputElement = document.getElementById(inputHtml.id || inputHtml.name); // Use id if available, fallback to name
      if (!inputElement) {
        console.warn(`Input element not found for ${inputHtml.name}`);
        return;
      }
      
      if (inputElement.type === 'checkbox') {
        tempMissingFields[inputHtml.name] = !inputElement.checked;
      } else {
        tempMissingFields[inputHtml.name] = !inputElement.value; // true if missing, false if has a value
      }
    });
   
     // Update state with missing fields at once
     return tempMissingFields // Where the function is invoked, setMissingFields(validateRequiredFields(...args))
}

export default validateRequiredFields